window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.vjsdatepicker').length) {
    import('./_datepicker.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}
